import last from 'lodash/last';

import { removeNonNumbers } from '@ott/transforms';
import cardValidators from '@ott/utility-card-validator';
import { isOldWebkit } from '@ott/utility-formatters';

import { Formatter } from '../types';

const NUMBER_REG = /\d/;
const DEFAULT_CARD_NUMBER_LENGTH = 19;

const getCardNumberMaxLength = (cardNumber: string): number => {
  const { card } = cardValidators.number(cardNumber);
  const cardLengths: number[] = card?.lengths || [];

  return last(cardLengths) || DEFAULT_CARD_NUMBER_LENGTH;
};

const cardNumberFormatter: Formatter = (value = '', previous = '', cursor = 0) => {
  let gaps = [4, 8, 12];
  let result = '';
  let resultCursor = cursor;
  const length = getCardNumberMaxLength(value);

  const { card } = cardValidators.number(removeNonNumbers(value));

  if (card) {
    if (card.type === 'visa' && length > 16) {
      gaps = [4, 8, 12, 16];
    } else if (card.gaps.length) {
      gaps = card.gaps;
    }
  }

  let gap = gaps.shift();

  for (let i = 0, j = 0; i < value.length && j < length; i++) {
    const c = value.charAt(i);

    if (NUMBER_REG.test(c)) {
      result += c;
      ++j;
    } else if (i < cursor) {
      --resultCursor;
    }

    // Не добавляем пробел после последнего символа
    if (j === gap && i < value.length - 1) {
      gap = gaps.shift();
      result += ' ';
      if (i < cursor) {
        ++resultCursor;
      }
    }
  }

  return {
    value: result,
    cursor: resultCursor,
  };
};

export const formatCardNumber = isOldWebkit ? removeNonNumbers : cardNumberFormatter;

export const parseCardNumber = (cardNumber: string): string => {
  const maxLength = getCardNumberMaxLength(cardNumber);

  return (cardNumber || '').replace(/\s/g, '').slice(0, maxLength);
};
